import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  admin,
} from '../../components/advanced-ui/advanced-ui.route';

import { bolletteRoutingModule } from '../../content/bollette/bollette.route';
import { CurveDiCaricoRoutingModule } from '../../content/curve-di-carico/curve-di-carico.route';
import { UtentiRoutingModule } from '../../content/utenti/utenti.route';
import { AssociazioniRoutingModule } from '../../content/associazioni/associazioni.route';
import { ChatbotRoutingModule } from '../../content/chatbot/chatbot.route';

//! INSERICI ROUTES
export const content: Routes = [
  {
    path: '',
    children: [
      ...bolletteRoutingModule.routes,
      ...CurveDiCaricoRoutingModule.routes,
      ...ChatbotRoutingModule.routes,
      ...UtentiRoutingModule.routes,
      ...AssociazioniRoutingModule.routes
    ],
  },
];
@NgModule({
  imports: [RouterModule.forRoot(admin)],
  exports: [RouterModule],
})
export class SaredRoutingModule {}
